import { GADimension } from '@ps/web-core-enums';

import type { Entity } from '../entities';
import { sportsCompetition, sportsEvent, sportsRace, sportsSport } from '../entities';
import { type LinkClick, linkClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import type { EventPageTabEntities, RacePageTabEntities } from '.';
import { getIsRaceBasedEntity } from './utils/getIsRaceBasedEntity';
import { mergeWithTrackingContextValue } from './utils/mergeWithTrackingContextValue';

interface TabClicked {
  entities: EventPageTabEntities | RacePageTabEntities;
  linkData: LinkClick;
}

export const marketTabClicked = (
  context: TrackingContextValue,
  { entities, linkData }: TabClicked
) => {
  const { destinationUrl, linkText, resolverTag } = linkData;

  if (getIsRaceBasedEntity(entities)) {
    const { raceId, sportId } = entities;
    const raceEntities: Entity[] = [sportsRace({ raceId }), sportsSport({ sportId })];

    context = mergeWithTrackingContextValue(context, raceEntities);

    GAEvent(
      { label: linkText ?? '', action: 'Hyperlink Pressed' },
      context,
      resolverTag ? { [GADimension.ResolverTag]: resolverTag } : {}
    );
    linkClick({ destinationUrl, linkText, resolverTag }, context);
  } else {
    const { eventId, sportId, competitionId, eventStartTime } = entities;

    const eventEntities: Entity[] = [
      sportsEvent({ eventId, eventStartTime: new Date(eventStartTime).getTime() }),
      sportsSport({ sportId })
    ];

    if (competitionId) {
      eventEntities.push(sportsCompetition({ competitionId }));
    }

    context = mergeWithTrackingContextValue(context, eventEntities);

    GAEvent(
      { label: linkText ?? '', action: 'Hyperlink Pressed' },
      context,
      resolverTag ? { [GADimension.ResolverTag]: resolverTag } : {}
    );
    linkClick({ destinationUrl, linkText, resolverTag }, context);
  }
};
